// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__iIpF8","box":"WorkspacesBox_box__1CDTZ","node":"WorkspacesBox_node__3BTdE"};